/* eslint-disable no-unused-vars */
import axios from "axios";
import moment from "moment";
import _ from "lodash";
import { apiServerUrl } from '../../config/config.json';

const url = `${apiServerUrl}/routes`;

String.prototype.allReplace = function(obj) {
  var retStr = this;
  for (var x in obj) {
    retStr = retStr.replace(new RegExp(x, "g"), obj[x]);
  }
  return retStr;
};

let messageConfig = {
  "<p>": "&lt;span&gt;",
  "</p>": "&lt;/span&gt;",
  'class="mention"':
    'class="mention" style="font-weight: bold; display: inline;"',
  "<": "&lt;",
  ">": "&gt;",
  // '&lt;': '<',
  // '&gt;': '>',
  "a href=": 'a target="_blank" href=',
};

let messageConfigDecrypt = {
  "&lt;": "<",
  "&gt;": ">",
};

const state = {
  containers: [],
  subroutes: [],
};

const getters = {
  openedSubRouteContainers: (state) => state.containers,
  getSubRoutes: (state) => state.subroutes,
};

const actions = {
  async addSubRouteContainer({ commit }, body) {
    commit("addContainer", body);
    return true;
  },
  async removeSubRouteSelection({ commit }, body) {
    commit("removeSelection", body);
  },
  async fetchParentSubRoutes({ commit }, parent_id) {
    // !FETCH SUBROUTES
    try {
      const authToken = localStorage.getItem("access_token");
      const response = await axios.get(
        `${url}/listParentSubRoutes/${parent_id}`,
        {
          headers: { "x-drmms-token": authToken },
        }
      );

      const data = [];
      let duration;
      let dateUntil;

      response.data.forEach((element) => {
        let formattedInstructions = element.instructions.allReplace(
          messageConfigDecrypt
        );
        element.instructions = formattedInstructions;
        element.isWarned = false;
        element.warningStatus = false;
        element.isDeleted = false;

        if (element.status == "Done") {
          duration = "Completed";
        } else if (element.status == "Overdue") {
          duration = "Overdue";
        } else if (element.status == "Pending") {
          dateUntil = moment(element.datetime_due);
        }

        let routeDue = moment(element.datetime_due).format("LLL");
        element.datetime_due = routeDue;
        element.duration_hours = duration;
        element.isWarned = false;
        element.notifLogCount = 0;

        data.push(element);
      });

      let routes = { parent_id, data };

      commit("addSubRoute", routes);
      return true;
    } catch (err) {
      if (err.response) {
        if (err.response.status == 400)
          return { error: true, status: 400, message: err.response.data };
        else if (err.response.status == 500)
          return { error: true, status: 500, message: "Internal Server Error" };
      }
    }
  },
  closeSubRoute({ commit }) {
    commit("popSubRoute", null);
  },
  closeSubRouteDetails({ commit }) {
    commit("clearSubRoutes", null);
  },
  async setSubRouteCompeleted({ commit }, body) {
    try {
      const authToken = localStorage.getItem("access_token");

      const response = await axios({
        method: "put",
        url: `${url}/assignedRoute/update/done/${body.route_id}`,
        headers: { "x-drmms-token": authToken },
      });

      commit("updateSubRouteCompletion", body);

      return response.data;
    } catch (err) {
      if (err.response) {
        if (err.response.status == 400)
          return { error: true, status: 400, message: err.response.data };
        else if (err.response.status == 403)
          return { error: true, status: 403, message: err.response.data };
        else if (err.response.status == 500)
          return { error: true, status: 500, message: "Internal Server Error" };
      }
    }
  },
  async addChildSubrouteOutputDocument({ commit }, body) {
    const { route_id } = body;
    let data = _.omit(body, ["route_type", "route_index", "container"]);
    try {
      const authToken = localStorage.getItem("access_token");
      let response = await axios.post(
        `${url}/subroutes/documents/add/output/${route_id}`,
        data,
        {
          headers: { "x-drmms-token": authToken },
        }
      );

      const commitObject = Object.assign(body, { created: response.data });

      commit("addChildOutputDocument", commitObject);
      return true;
    } catch (err) {
      if (err.response) {
        if (err.response.status == 400)
          return { error: true, status: 400, message: err.response.data };
        else if (err.response.status == 500)
          return { error: true, status: 500, message: "Internal Server Error" };
      }
    }
  },
  async attachChildSubrouteRecord({ commit }, body) {
    let { type, route_id, records, remarks } = body;

    let customUrl = `${url}/subroute/records/attach/${route_id}`;

    let record_ids = [];

    try {
      let currentRecords;

      let index1 = state.subroutes.findIndex(
        (sub) => sub.parent_id == body.container
      );

      if (index1 !== -1) {
        let selectedSubroutes = state.subroutes[index1];

        let index2 = selectedSubroutes.data.findIndex((d) => d.id == route_id);
        if (index2 !== -1) {
          currentRecords = state.subroutes[index1].data[index2].records;

          body.route_index = index2;

          let currentIds = [];
          let newRecords = [];

          currentRecords.forEach((element) => currentIds.push(element.id));

          records.forEach((element) => {
            if (!currentIds.includes(element.id)) {
              newRecords.push(element);
              record_ids.push(element.id);
            }
          });

          const authToken = localStorage.getItem("access_token");
          const response = await axios.post(
            customUrl,
            { record_ids, remarks },
            { headers: { "x-drmms-token": authToken } }
          );

          body.records = newRecords;

          commit("setChildRouteAttachedRecords", body);
          return true;
        }
      }
    } catch (err) {
      console.log(err);
    }
  },
  async attachToSubRouteParentOutputDocument({ commit }, body) {
    const { parent_id } = body;
    const data = _.omit(body, ["document", "parent_id"]);
    try {
      const authToken = localStorage.getItem("access_token");
      let response = await axios.post(
        `${url}/parent/documents/add/output/${parent_id}`,
        data,
        {
          headers: { "x-drmms-token": authToken },
        }
      );

      commit("attachParentSubRouteOutputDocument", body);
      return true;
    } catch (err) {
      if (err.response) {
        if (err.response.status == 400)
          return { error: true, status: 400, message: err.response.data };
        else if (err.response.status == 500)
          return { error: true, status: 500, message: "Internal Server Error" };
      }
    }
  },
  async addChildSubrouteSupportingDocument({ commit }, body) {
    const { route_id } = body;
    try {
      const authToken = localStorage.getItem("access_token");
      let response = await axios.post(
        `${url}/subroutes/documents/add/supporting/${route_id}`,
        body,
        {
          headers: { "x-drmms-token": authToken },
        }
      );

      const commitObject = Object.assign(body, { created: response.data });

      commit("addChildSubrouteSupportingDocument", commitObject);
      return true;
    } catch (err) {
      if (err.response) {
        if (err.response.status == 400)
          return { error: true, status: 400, message: err.response.data };
        else if (err.response.status == 500)
          return { error: true, status: 500, message: "Internal Server Error" };
      }
    }
  },
  async addChildSubRouteStatus({ commit }, body) {
    const route_id = body.route_id;
    const status_id = body.status.id;
    const status = body.status;

    try {
      const authToken = localStorage.getItem("access_token");
      const response = await axios.post(
        `${url}/addSubRouteStatus/${route_id}`,
        { status_id },
        { headers: { "x-drmms-token": authToken } }
      );

      if (response.data) commit("addedChildSubRouteStatus", body);
      return status;
    } catch (err) {
      if (err.response) {
        if (err.response.status == 400)
          return { error: true, status: 400, message: err.response.data };
        else if (err.response.status == 500)
          return { error: true, status: 500, message: "Internal Server Error" };
      }
    }
  },
  addSubrouteCommentCount({ commit }, body) {
    commit("setNewSubrouteComment", body);
  },
  async subRouteUpdateDocumentVersion({ commit }, body) {
    try {
      const authToken = localStorage.getItem("access_token");
      const response = await axios.post(
        `${apiServerUrl}/documents/uploadNewVersion/${body.document_id}`,
        body,
        {
          headers: { "x-drmms-token": authToken },
        }
      );

      body.newInstance = response.data;

      commit("updateNewSubRouteDocumentSource", body);
      return true;
    } catch (err) {
      console.log(err);
      if (err.response) {
        if (err.response.status == 400)
          return { error: true, status: 400, message: err.response.data };
        else if (err.response.status == 500)
          return { error: true, status: 500, message: "Internal Server Error" };
      }
    }
  },
  async removeSubRouteDocument({ commit }, body) {
    try {
      const authToken = localStorage.getItem("access_token");
      const response = await axios({
        method: "delete",
        url: `${url}/assignedRoute/document/${body.route_id}/${body.initiator_id}`,
        data: body,
        headers: { "x-drmms-token": authToken },
      });

      commit("removeDocumentFromSubRoute", body);
      return true;
    } catch (err) {
      console.log(err);
      if (err.response) {
        if (err.response.status == 400)
          return { error: true, status: 400, message: err.response.data };
        else if (err.response.status == 500)
          return { error: true, status: 500, message: "Internal Server Error" };
      }
    }
  },
  async removeSubRouteRecord({ commit }, body) {
    try {
      const authToken = localStorage.getItem("access_token");
      const response = await axios({
        method: "delete",
        url: `${url}/assignedRoute/record/${body.initiator_id}/${body.route_id}`,
        data: body,
        headers: { "x-drmms-token": authToken },
      });

      commit("removeRecordFromSubRoute", body);
      return true;
    } catch (err) {
      console.log(err);
      if (err.response) {
        if (err.response.status == 400)
          return { error: true, status: 400, message: err.response.data };
        else if (err.response.status == 500)
          return { error: true, status: 500, message: "Internal Server Error" };
      }
    }
  },
  async setSubRouteOverdue({ commit }, body) {
    const { route_id, type } = body;

    if (body.type == "mainroute") {
      console.log("setting it boi: ", body);
    }

    try {
      const authToken = localStorage.getItem("access_token");
      let response = await axios({
        method: "put",
        url: `${url}/assignedRoute/update/overdue/${route_id}`,
        headers: { "x-drmms-token": authToken },
      });

      commit("setOverdueSubRoute", body);
    } catch (err) {
      console.log(err);
    }
  },
  warnSubRouteStatus({ commit }, body) {
    commit("updateSubRouteStatusWarning", body);
  },
  addRequestToSubRoute({ commit }, body) {
    commit("setAddedRequestToSubRoute", body);
  },
  async fetchSubRouteLog({ commit }, body) {
    let { route_id } = body;

    let customUrl = `${url}/activity/logs/secondaryroute/${route_id}`

    try {
        const authToken = localStorage.getItem("access_token");
        const response = await axios.get(customUrl, {
          headers: {
            "x-drmms-token": authToken,
          },
        });
  
        let logs = [];
        let notifLogCount = 0;
  
        response.data.forEach((l) => {
          logs.push({
            from: `${l.user.first_name} ${l.user.last_name}`,
            message: l.description,
            time: moment(l.createdAt).format("lll"),
            color: l.route_log_color,
            icon: l.route_log_icon,
            id: l.id,
            notifStatus: l.notifStatus,
          });
          if (l.notifStatus) notifLogCount++;
        });
  
        const commitBody = {
          ...body,
          notifLogCount,
          logs,
        };
        commit("addSubRouteLog", commitBody);
  
        return logs;
      } catch (err) {
        console.log(err);
      }
  },
  async updateSubRouteAutoComplete({ commit }, body) {
    try {
      const authToken = localStorage.getItem("access_token");

      await axios({
        method: 'put',
        url: `${url}/trigger/autocomplete/${body.route_id}`,
        data: { status: body.status },
        headers: { "x-drmms-token": authToken }
      });

      commit('updateSubRouteAutoCompleteStatus', body);

    } catch(err) {
      console.log(err);
    }
  }
};

const mutations = {
  addContainer: (state, container) => {
    let index = container.index + 1;
    let id = container.id;

    if (state.containers.length < 1) state.containers.push(container.id);
    else {
      if (!state.containers[index]) state.containers.push(id);
      else {
        if (id != state.containers[index]) {
          let numOfExtra = state.containers.length - index;

          for (var i = 0; i < numOfExtra; i++) {
            state.containers.pop();
            state.subroutes.pop();
          }

          state.containers[index] = id;
        }
      }
    }
  },
  addSubRoute: (state, subroutes) => {
    let data = subroutes.data.map((routes) => ({
      ...routes,
      datetime_due: moment(routes.datetime_due).format("LLL"),
      warningStatus: false,
      isWarned: false,
    }));

    let lastIndex = state.subroutes.length;
    subroutes.index = lastIndex;
    subroutes.data = data;
    state.subroutes.push(subroutes);
  },
  popSubRoute: (state, route) => state.subroutes.pop(),
  clearSubRoutes: (state, route) => {
    state.containers = [];
    state.subroutes = [];
  },
  removeSelection: (state, subroute) => {
    let index = subroute.index + 1;

    for (var i = state.containers.length; i > index; i--) {
      state.containers.pop();
      state.subroutes.pop();
    }
  },
  addChildOutputDocument: (state, documents) => {
    const { route_id, created, container } = documents;

    let index1 = state.subroutes.findIndex((sub) => sub.parent_id == container);

    if (index1 !== -1) {
      let selectedSubroutes = state.subroutes[index1];

      let index2 = selectedSubroutes.data.findIndex((d) => d.id == route_id);
      if (index2 !== -1) {
        state.subroutes[index1].data[index2].document_instances.push(created);
      }
    }
  },
  setChildRouteAttachedRecords: (state, body) => {
    const { records, route_id, created, container, remarks } = body;

    let index1 = state.subroutes.findIndex((sub) => sub.parent_id == container);

    if (index1 !== -1) {
      let selectedSubroutes = state.subroutes[index1];

      let index2 = selectedSubroutes.data.findIndex((d) => d.id == route_id);
      if (index2 !== -1) {
        let currentRecords = state.subroutes[index1].data[index2].records;

        records.forEach((record) => {
          record.record_subroute = [{ remarks }];
        });

        currentRecords = currentRecords.concat(records);
        let assigned_route = state.subroutes[index1].data[index2];
        assigned_route.records = currentRecords;

        state.subroutes[index1].data.splice(index2, 1, assigned_route);
      }
    }
  },
  attachParentSubRouteOutputDocument: (state, body) => {
    const { parent_id, document } = body;

    let index1 = null;
    let index2 = null;

    state.subroutes.forEach((subroute, idx1) => {
      subroute.data.forEach((d, idx2) => {
        if (d.id == parent_id) {
          index1 = idx1;
          index2 = idx2;
          return;
        }
      });
    });

    if (index1 != null && index2 != null) {
      document.document_route_assignments.user_route_assignment_id = parseInt(
        parent_id
      );
      state.subroutes[index1].data[index2].document_instances.push(document);
    }
  },
  addChildSubrouteSupportingDocument: (state, body) => {
    const { route_id, created, container, remarks } = body;

    let index1 = state.subroutes.findIndex((sub) => sub.parent_id == container);

    if (index1 !== -1) {
      let selectedSubroutes = state.subroutes[index1];

      let index2 = selectedSubroutes.data.findIndex((d) => d.id == route_id);
      if (index2 !== -1) {
        created.document.remarks = remarks;
        state.subroutes[index1].data[index2].document_instances.push(created);
      }
    }
  },
  addedChildSubRouteStatus: (state, body) => {
    const { route_id, container, status } = body;

    let index1 = state.subroutes.findIndex((sub) => sub.parent_id == container);

    if (index1 !== -1) {
      let selectedSubroutes = state.subroutes[index1];

      let index2 = selectedSubroutes.data.findIndex((d) => d.id == route_id);
      if (index2 !== -1) {
        state.subroutes[index1].data[index2].statuses.push(status);
      }
    }
  },
  setNewSubrouteComment: (state, body) => {
    const { newComment, selected_route_id, container } = body;
    let index1 = state.subroutes.findIndex((sub) => sub.parent_id == container);

    if (index1 !== -1) {
      let selectedSubroutes = state.subroutes[index1];

      let index2 = selectedSubroutes.data.findIndex(
        (d) => d.id == selected_route_id
      );
      if (index2 !== -1) {
        state.subroutes[index1].data[index2].assigned_route_comments.push(
          newComment
        );
      }
    }
  },
  updateNewSubRouteDocumentSource: (state, data) => {
    const {
      route_id,
      document_instance_id,
      filepath_url,
      type,
      container,
    } = data;

    let index1 = state.subroutes.findIndex((sub) => sub.parent_id == container);

    if (index1 !== -1) {
      let selectedSubroutes = state.subroutes[index1];

      let routeIndex = selectedSubroutes.data.findIndex(
        (route) => route.id == route_id
      );

      if (routeIndex !== -1) {
        let selectedRoute = state.subroutes[index1].data[routeIndex];
        let documentIndex = selectedRoute.document_instances.findIndex(
          (d) => d.id == document_instance_id
        );

        if (documentIndex !== -1) {
          state.subroutes[index1].data[routeIndex].document_instances[
            documentIndex
          ].filepath_url = filepath_url;
        }
      }
    }
  },
  removeDocumentFromSubRoute: (state, body) => {
    const {
      route_id,
      initiator_id,
      route_type,
      document_id,
      document_type,
      container,
      document_instance_id,
    } = body;

    let index1 = state.subroutes.findIndex((sub) => sub.parent_id == container);

    if (index1 !== -1) {
      let selectedSubroutes = state.subroutes[index1];

      let routeIndex = selectedSubroutes.data.findIndex(
        (route) => route.id == route_id
      );

      if (routeIndex !== -1) {
        let selectedRoute = state.subroutes[index1].data[routeIndex];

        let newDocuments = selectedRoute.document_instances.filter(
          (document) => document.id != document_id
        );
        state.subroutes[index1].data[
          routeIndex
        ].document_instances = newDocuments;
      }
    }
  },
  removeRecordFromSubRoute: (state, body) => {
    const { route_id, initiator_id, route_type, record_id, container } = body;

    let index1 = state.subroutes.findIndex((sub) => sub.parent_id == container);

    if (index1 !== -1) {
      let selectedSubroutes = state.subroutes[index1];

      let routeIndex = selectedSubroutes.data.findIndex(
        (route) => route.id == route_id
      );

      if (routeIndex !== -1) {
        let selectedRoute = state.subroutes[index1].data[routeIndex];

        let newRecords = selectedRoute.records.filter(
          (record) => record.id != record_id
        );
        state.subroutes[index1].data[routeIndex].records = newRecords;
      }
    }
  },
  setOverdueSubRoute: (state, body) => {
    let { route_id, container } = body;

    let index1 = state.subroutes.findIndex((sub) => sub.parent_id == container);

    if (index1 !== -1) {
      let selectedSubroutes = state.subroutes[index1];
      let routeIndex = selectedSubroutes.data.findIndex(
        (route) => route.id == route_id
      );

      if (routeIndex !== -1) {
        state.subroutes[index1].data[routeIndex].overdue_status = true;
        state.subroutes[index1].data[routeIndex].isWarned = true;
      }
    }
  },
  updateSubRouteStatusWarning: (state, body) => {
    let { route_id, container } = body;

    let index1 = state.subroutes.findIndex((sub) => sub.parent_id == container);

    if (index1 !== -1) {
      let selectedSubroutes = state.subroutes[index1];
      let routeIndex = selectedSubroutes.data.findIndex(
        (route) => route.id == route_id
      );

      if (routeIndex !== -1) {
        state.subroutes[index1].data[routeIndex].warningStatus = true;
        state.subroutes[index1].data[routeIndex].isWarned = true;
      }
    }
  },
  setAddedRequestToSubRoute: (state, body) => {
    let { user_route_assignment_id, container } = body;
    let route_id = user_route_assignment_id;

    let index1 = state.subroutes.findIndex((sub) => sub.parent_id == container);

    if (index1 !== -1) {
      let selectedSubroutes = state.subroutes[index1];
      let routeIndex = selectedSubroutes.data.findIndex(
        (route) => route.id == route_id
      );

      if (routeIndex !== -1) {
        state.subroutes[index1].data[routeIndex].route_record_requests.push(
          body
        );
      }
    }
  },
  updateSubRouteCompletion: (state, body) => {
    let { route_id, route_index, container } = body;

    let index1 = state.subroutes.findIndex((sub) => sub.parent_id == container);

    if (index1 !== -1) {
      let selectedSubroutes = state.subroutes[index1];
      let routeIndex = selectedSubroutes.data.findIndex(
        (route) => route.id == route_id
      );

      if (routeIndex !== -1) {
        state.subroutes[index1].data[routeIndex].status = "Done";
      }
    }
  },
  addSubRouteLog: (state, body) => {
      const { route_id, parent_id, logs, notifLogCount } = body;

      let index1 = state.subroutes.findIndex((sub) => sub.parent_id == parent_id);

      if(index1 !== -1) {
          let selectedSubroutes = state.subroutes[index1];
          let routeIndex = selectedSubroutes.data.findIndex((route) => route.id == route_id);

          if(routeIndex !== -1) {
              state.subroutes[index1].data[routeIndex].logs = logs;
              state.subroutes[index1].data[routeIndex].notifLogCount = notifLogCount;
          }
      }
  },
  updateSubRouteAutoCompleteStatus: (state, body) => {
    const { status, route_id, container } = body;

    let index1 = state.subroutes.findIndex((sub) => sub.parent_id == container);

    if(index1 !== -1) {
      let selectedSubroutes = state.subroutes[index1];
      let routeIndex = selectedSubroutes.data.findIndex(
        (route) => route.id == route_id
      );

      if (routeIndex !== -1) {
        state.subroutes[index1].data[routeIndex].autoCompleteTrigger = status;
      }
    }
  }
};

export default {
  state,
  getters,
  actions,
  mutations,
};
